export default __webpack_public_path__ + "static/media/bpaLogo.51e67c94.png";